import PropTypes from 'prop-types'
import React from 'react'
import styles from './_pageHeader.css'

export default function PageHeader ({ children }) {
  return (
    <div className={styles.pageHeaderContainer}>
      {children}
    </div>
  )
}

PageHeader.propTypes = {
  children: PropTypes.node,
}



// WEBPACK FOOTER //
// ./src/components/util/PageHeader.jsx